import { ArrowForwardIos, CallSplit, ContentCopy, Delete } from "@mui/icons-material";
import React, { memo, useMemo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { i18n } from "../../../translate/i18n";

const clampPercent = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  if (parsed < 0) return 0;
  if (parsed > 100) return 100;
  return Math.round(parsed);
};

const normalizeDistribution = (data) => {
  if (Array.isArray(data?.distribution) && data.distribution.length >= 2) {
    return data.distribution.map(clampPercent);
  }

  const legacyPercent = clampPercent(data?.percent);
  if (legacyPercent > 0 && legacyPercent < 100) {
    return [legacyPercent, 100 - legacyPercent];
  }

  return [50, 50];
};

const getHandleId = (index) => {
  if (index === 0) return "a";
  if (index === 1) return "b";
  return `r${index}`;
};

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  const distribution = useMemo(() => normalizeDistribution(data || {}), [data]);
  const rowsTop = 42;
  const rowSpacing = 26;
  const nodeHeight = Math.max(92, rowsTop + distribution.length * rowSpacing + 8);

  return (
    <div
      style={{
        backgroundColor: "#F8FCFD",
        padding: "8px",
        borderRadius: "8px",
        width: "190px",
        minHeight: `${nodeHeight}px`,
        border: "1px solid rgba(31, 186, 220, 0.25)",
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#0000FF",
          width: "18px",
          height: "18px",
          top: "20px",
          left: "-12px",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "3.5px",
            marginBottom: "1px",
            pointerEvents: "none",
          }}
        />
      </Handle>

      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "12px", height: "12px", color: "#1FBADC" }}
        />

        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "12px", height: "12px", color: "#1FBADC" }}
        />
      </div>

      <div
        style={{
          color: "#ededed",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex",
          marginBottom: "6px",
        }}
      >
        <CallSplit
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
            color: "#1FBADC",
          }}
        />
        <div style={{ color: "#232323", fontSize: "16px" }}>
          {i18n.t("flowBuilderConfig.nodes.randomizer.title")}
        </div>
      </div>

      {distribution.map((percent, index) => {
        const topPosition = rowsTop + index * rowSpacing;
        return (
          <React.Fragment key={`randomizer-handle-${getHandleId(index)}`}>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "14px",
                position: "relative",
                color: "#232323",
                marginBottom: "6px",
              }}
            >
              {`${percent}%`}
            </div>

            <Handle
              type="source"
              position="right"
              id={getHandleId(index)}
              style={{
                background: "#0000FF",
                width: "18px",
                height: "18px",
                right: "-11px",
                top: topPosition,
                cursor: "pointer",
              }}
              isConnectable={isConnectable}
            >
              <ArrowForwardIos
                sx={{
                  color: "#ffff",
                  width: "10px",
                  height: "10px",
                  marginLeft: "2.9px",
                  marginBottom: "1px",
                  pointerEvents: "none",
                }}
              />
            </Handle>
          </React.Fragment>
        );
      })}
    </div>
  );
});
